import { createContext, useContext } from 'react';

import { widgetsConfigStore } from './widgets-config.store';

import type { ScheduleFilterMode, WidgetEntry } from './widgets.types';

export type WidgetConfigStore = {
  entries: WidgetEntry[];
  scheduleFilterMode: ScheduleFilterMode;
  isCollapsed: (key: string) => boolean;
  setCollapsed: (key: string, collapsed: boolean) => void;
  setScheduleFilterMode: (mode: ScheduleFilterMode) => void;
};

export type WidgetDisplayMode = 'card' | 'home';

export type WidgetDisplayContextValue = {
  configStore: WidgetConfigStore;
  mode: WidgetDisplayMode;
};

export const WidgetDisplayContext = createContext<WidgetDisplayContextValue>({
  configStore: widgetsConfigStore,
  mode: 'card',
});

export const useWidgetDisplay = (): WidgetDisplayContextValue =>
  useContext(WidgetDisplayContext);
